import PropTypes from 'prop-types'
import useStyles, { getDynamicTooltipStyles } from './styles'

// Tooltip overlay component that follows mouse cursor with CSS animations
const TooltipOverlay = ({ tooltip, isVisible, mousePosition }) => {
  const classes = useStyles()
  const { x, y } = mousePosition
  const offsetX = 12 // Distance from cursor
  const offsetY = -8

  // Get dynamic styles based on current state
  const dynamicStyles = getDynamicTooltipStyles({
    x,
    y,
    offsetX,
    offsetY,
    isVisible,
    hasTooltip: !!tooltip
  })

  return (
    <div className={classes.tooltip} style={dynamicStyles}>
      {tooltip && (
        <>
          <div className={classes.title}>{tooltip.title}</div>
          {tooltip.items.map((item, index) => (
            <div key={index}>
              {item.label}: {item.value}
            </div>
          ))}
        </>
      )}
    </div>
  )
}

TooltipOverlay.propTypes = {
  tooltip: PropTypes.shape({
    title: PropTypes.string.isRequired,
    items: PropTypes.arrayOf(
      PropTypes.shape({
        label: PropTypes.string.isRequired,
        value: PropTypes.string.isRequired
      })
    ).isRequired
  }),
  isVisible: PropTypes.bool.isRequired,
  mousePosition: PropTypes.shape({
    x: PropTypes.number.isRequired,
    y: PropTypes.number.isRequired
  }).isRequired
}

export default TooltipOverlay
